import script from "./IAConfiguracoes.vue?vue&type=script&setup=true&lang=js"
export * from "./IAConfiguracoes.vue?vue&type=script&setup=true&lang=js"

import "./IAConfiguracoes.vue?vue&type=style&index=0&id=6f494e5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f494e5c"]])

export default __exports__